import {Component} from 'preact'
import style from './style.scss'

class CategoryScroll extends Component{
    render() {
        const { isAnimating, isFocused, color, activeCategory } = this.props;
        const xTranslate = (activeCategory % 3) * 100;
        const display = this.props.display
        if (display) {
            return (
                <div className={style.Scroller}>
                    <div style={{transform: `translateX(${xTranslate}%)`}} className={style.LineWrapper}>
                        <div className={style.Line} style={{backgroundColor: color}}></div>
                    </div>
                </div>
            )
        } else {
            return null;
        }
    }
}

export default CategoryScroll;



// WEBPACK FOOTER //
// ./routes/HelpDesk/CategoryScroll/CategoryScroll.js